export default class CancelCallTransfersSelector {
  public static selectCancelTransferField(state: ReduxState) {
    return state.cancelCallTransfer.cancelTransferField;
  }
}
